export default function RefundPolicy() {
    return (
        <div className="min-h-screen bg-cream">
            <div className="max-w-4xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-24">
                <div className="mb-12">
                    <h1 className="font-display text-5xl md:text-6xl font-extrabold tracking-tight mb-4">
                        Refund Policy
                    </h1>
                    <p className="text-ink/60 font-body text-lg">
                        Last updated: June 3, 2026
                    </p>
                </div>

                <div className="prose prose-lg max-w-none font-body text-ink space-y-6">
                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">1. Refund Eligibility</h2>
                        <p>
                            Technovale Solutions offers refunds under the following conditions:
                        </p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Request must be made within 30 days of purchase</li>
                            <li>Service must not have been fully delivered or utilized</li>
                            <li>Payment must have been successfully processed</li>
                            <li>No chargebacks have been filed</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">2. Refund Process</h2>
                        <p>
                            To request a refund, please contact us at <strong>info@technovalesolutions.com</strong> with:
                        </p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Your order or invoice number</li>
                            <li>Reason for refund request</li>
                            <li>Date of purchase</li>
                            <li>Any relevant documentation or correspondence</li>
                        </ul>
                        <p className="mt-4">
                            We will review your request within 5-7 business days and notify you of the outcome.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">3. Refund Timeline</h2>
                        <p>
                            If your refund is approved, the funds will be returned to your original payment method within 7-14 business days. Please note that depending on your financial institution, it may take an additional 3-5 business days for the credit to appear in your account.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">4. Non-Refundable Items</h2>
                        <p>The following are non-refundable:</p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Services already rendered or substantially completed</li>
                            <li>Custom development work or design services initiated</li>
                            <li>Subscriptions active for more than 30 days</li>
                            <li>Digital downloads or delivered materials</li>
                            <li>Support or consulting services provided</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">5. Partial Refunds</h2>
                        <p>
                            For services that have been partially delivered, we may issue a partial refund based on the proportion of services rendered. The determination will be made on a case-by-case basis during our review process.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">6. Special Cases</h2>
                        <h3 className="text-xl font-bold font-display mt-6 mb-3">Disputes and Chargebacks</h3>
                        <p>
                            Filing a chargeback or dispute without attempting to resolve the issue directly with us first will result in forfeiture of refund eligibility and may result in legal action.
                        </p>
                        <h3 className="text-xl font-bold font-display mt-6 mb-3">Cancelled Services</h3>
                        <p>
                            If you cancel a subscription or ongoing service, refunds for the remaining period will be calculated on a pro-rata basis.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">7. Contact Us</h2>
                        <p>
                            For refund requests or inquiries, please contact:
                        </p>
                        <div className="mt-4 p-6 bg-ink/5 border-2 border-ink/20">
                            <p className="font-bold">Technovale Solutions</p>
                            <p>Email: info@technovalesolutions.com</p>
                            <p>Phone: +91 (931) 074-5117</p>
                            <p>Address: 188, Sector 48, Gurugram, HR</p>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">8. Policy Changes</h2>
                        <p>
                            We reserve the right to modify this refund policy at any time. Changes will be effective immediately upon posting to our website. Continued use of our services after policy changes indicates your acceptance of the new terms.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
}
